import { FC } from 'react';
import { PageHero, PageHeroNotification, Typography, Button } from '@dreamteam-monorepo/ui';

export interface LeaguesPageHeroProps {
  title: string;
  subtitle?: string;
  onJoinLeague?: () => void;
  onCreateLeague?: () => void;
  notification?: PageHeroNotification;
  className?: string;
}

export const LeaguesPageHero: FC<LeaguesPageHeroProps> = ({
  title,
  subtitle,
  onJoinLeague,
  onCreateLeague,
  notification,
  className,
}) => (
  <PageHero notification={notification} className={className}>
    <div className="flex flex-col gap-[--padding-md] sm:flex-row sm:items-end sm:justify-between">
      <div className="flex flex-col gap-[--padding-sm]">
        <Typography
          as="h1"
          variant="headline050"
          className="text-[--page-header-header] !font-[900] sm:text-40 sm:leading-44"
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="subheadline030" className="text-[--page-header-header]">
            {subtitle}
          </Typography>
        )}
      </div>

      {(onJoinLeague || onCreateLeague) && (
        <div className="flex gap-[--padding-sm] w-full sm:w-auto sm:shrink-0">
          {onJoinLeague && (
            <Button
              variant="contained"
              color="blue"
              onClick={onJoinLeague}
              className="flex-1 sm:flex-none sm:w-[160px]"
            >
              Join League
            </Button>
          )}
          {onCreateLeague && (
            <Button
              variant="outlined"
              color="blue"
              onClick={onCreateLeague}
              className="flex-1 sm:flex-none sm:w-[160px]"
            >
              Create League
            </Button>
          )}
        </div>
      )}
    </div>
  </PageHero>
);
